// @generated by libs/zero-schema/codegen/generate-date-columns.ts — do not edit.
// Regenerate with `pnpm zero:generate`.

/**
 * Date and timestamp columns per synced Zero table, derived from the Drizzle
 * schema. Zero delivers both kinds as epoch-ms numbers on the wire:
 * - 'date': `date(..., { mode: 'string' })` columns (epoch ms at UTC midnight).
 * - 'timestamp': `timestamp with time zone` columns (epoch ms).
 * Consumed by normalize-zero-row.ts (runtime) and its NormalizedRow type
 * (compile time). Adding a synced table regenerates this map automatically.
 */
export const DATE_COLUMNS = {
  AmsClassicWorkout: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  AthleteActualWorkoutLayer: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  AthleteDraftWorkoutLayer: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    assignedDate: 'date',
    deletedAt: 'timestamp',
  },
  AthleteModifiedPublishedWorkoutLayer: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  AthletePublishedWorkoutLayer: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    statusUpdatedAt: 'timestamp',
    assignedDate: 'date',
  },
  AthleteTransferredBlock: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  AthleteTransferredTrack: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  Block: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    startDate: 'date',
    endDate: 'date',
    deletedAt: 'timestamp',
  },
  BlockDraftWorkoutLayer: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    assignedDate: 'date',
    deletedAt: 'timestamp',
  },
  BlockFocus: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  BlockPrintTask: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  BlockPublishTask: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  BlockPublishedWorkoutLayer: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    assignedDate: 'date',
  },
  CoachTeamMembership: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  OrgSettings: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  Phase: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    startDate: 'date',
    endDate: 'date',
  },
  Profile: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    birthdate: 'date',
  },
  ProfilePermission: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  ProfileRole: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  ProfileTeamMembership: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  AthleteTeamAttributes: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  Track: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    deletedAt: 'timestamp',
    archivedAt: 'timestamp',
  },
  TrackAthlete: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
    deletedAt: 'timestamp',
  },
  TrainingFocus: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
  TrainingType: {
    createdAt: 'timestamp',
    updatedAt: 'timestamp',
  },
} as const;

export type DateColumns = typeof DATE_COLUMNS;
